const conversion = {
  "%%sur%%" : {
    "km²":{
      0: 1000000.0,
      1: 0.000001
    },
    "m²":{
      0: 1.0,
      1: 1.0
    },
    "cm²":{
      0: 0.0001,
      1: 10000.0
    },
    "ha":{
      0: 10000.0,
      1: 0.0001
    },
    "yd²":{
      0: 0.83612736,
      1: 1.19599004630108026
    },
    "ft²":{
      0: 0.09290304,
      1: 10.7639104167097223
    },
    "in²":{
      0: 0.00064516,
      1: 1550.00310000620001
    }
  },
  "%%dur%%" : {
    "Y": {
      0: 31536000.0,
      1: 0.0000000317097919837645865
    },
    "M": {
      0: 2628000,
      1: 0.0000003805175
    },
    "Day": {
      0: 86400.0,
      1: 0.0000115740740740740741
    },
    "H": {
      0: 3600.0,
      1: 0.000277777777777777778
    },
    "mn": {
      0: 60.0,
      1: 0.0166666666666666667
    },
    "s": {
      0: 1.0,
      1: 1.0
    }
  },
  "%%sdist%%" : {
    "mm" : {
      0: 10.0,
      1: 0.01
    },
    "cm" : {
      0: 1.0,
      1: 1.0
    },
    "in" : {
      0: 0.3937007874,
      1: 2.54
    }
  },
  "%%press%%" : {
    "MPa": {
      0: 1000000.0,
      1: 0.000001
    },
    "KPa": {
      0: 1000.0,
      1: 0.001
    },
    "HP": {
      0: 100.0,
      1: 0.01
    },
    "P": {
      0: 1.0,
      1: 1.0
    },
    "bar": {
      0: 100000.0,
      1: 0.00001
    },
    "psi": {
      0: 6894.757293168361,
      1: 0.000145037737730209222
    }
  },
  "%%mdist%%" : {
    "km" : {
      0: 1000.0,
      1: 0.001
    },
    "mile" : {
      0: 1609.344,
      1: 0.00062137119223733397
    },
    "m" : {
      0: 1.0,
      1: 1.0
    },
    "cm" : {
      0: 0.01,
      1: 100.0
    },
    "dm" : {
      0: 0.1,
      1: 10.0
    },
    "yd" : {
      0: 0.9144,
      1: 1.09361329833770779
    },
    "ft" : {
      0: 0.3048,
      1: 3.28083989501312336
    },
    "in" : {
      0: 0.0254,
      1: 39.3700787401574803
    },
    "inch" : {
      0: 0.0254,
      1: 39.3700787401574803
    }
  },
  "%%SperL%%" : {
    "m²/l": {
      0: 1.0,
      1: 1.0
    },
    "ft²/l": {
      0: 0.09290304,
      1: 10.76391041671
    },
    "ft²/gal-UK": {
      0: 0.0204358,
      1: 48.9337
    },
    "ft²/gal-US": {
      0: 0.0245423866,
      1: 40.74583357757065
    }
  },
  "%%vol%%" : {
    "gal (US)": {
      0: 0.003785411784,
      1: 264.172052358148415
    },
    "gal (UK)": {
      0: 0.00454609,
      1: 219.9692482990877875273
    },
    "dl": {
      0: 0.00001,
      1: 100000.0
    },
    "L": {
      0: 0.001,
      1: 1000.0
    },
    "cm³": {
      0: 0.000001,
      1: 1000000.0
    },
    "m³": {
      0: 1.0,
      1: 1.0
    },
    "in³": {
      0: 0.000016387064,
      1: 61023.744094732284
    },
    "ft³": {
      0: 0.028316846592,
      1: 35.3146667214885903
    },
    "yd³": {
      0: 0.7645548692741148,
      1: 1.3079506
    }
  },
  "%%speed%%" : {
    "kmh": {
      0: 0.27777777777778,
      1: 3.6
    },
    "mph": {
      0: 0.44704,
      1: 2.2369362920544
    },
    "ms": {
      0: 1.0,
      1: 1.0
    },
    "knot": {
      0: 0.51444444444444,
      1: 1.9438444924406
    },
    "mach": {
      0: 0.0008162972,
      1: 1225.044
    }
  },
  "%%power%%" : {

    "W": {
      0: 1.0,
      1: 1.0
    },
    "KW": {
      0: 1000.0,
      1: 0.001
    },
    "MW": {
      0: 1000000.0,
      1: 0.000001
    },
    "HP": {
      0: 735.49875,
      1: 0.00135962161730390432
    },
    "ps": {
      0: 0.001359622,
      1: 735.49875
    },
    "KILOCALORIE_S": {
      0: 0.00023884589662749592,
      1: 4186.8
    },
    "KILOCALORIE_H": {
      0: 0.859845227859,
      1: 1.163
    }
  },
  "%%lumen%%" : {
    "Candela": {
      0: 1.0,
      1: 1.0
    },
    "Lumen": {
      0: 1.0,
      1: 1.0
    },
    "Watts": {
      0: 1.0,
      1: 1.0
    },
  },
  "%%poids%%" : {
    "kg": {
      0: 1.0,
      1: 1.0
    },
    "lb": {
      0: 0.45359237,
      1: 2.20462262184877581
    },
    "g": {
      0: 0.001,
      1: 1000.0
    },
    "oz": {
      0: 0.028349523125,
      1: 35.27396194958041291568
    },
    "ton": {
      0: 1000.0,
      1: 0.001
    }
  },
  "%%energy%%" : {
    "JOULE": {
      0: 1.0,
      1: 1.0
    },
    "KILOJOULE": {
      0: 1000.0,
      1: 0.001
    },
    "CALORIE": {
      0: 4.184,
      1: 0.2390057361376673040153
    },
    "KILOCALORIE": {
      0: 4184.0,
      1: 0.0002390057361376673040153
    },
    "BTU": {
      0: 1055.05585262,
      1: 0.0009478171203133172000128
    },
    "FT_LBF": {
      0: 1.3558179483314004,
      1: 0.7375621494575464935503
    },
    "IN_LBF": {
      0: 0.1129848290276167,
      1: 8.850745793490557922604
    },
    "KILOWATT_HOUR": {
      0: 3600000.0,
      1: 0.0000002777777777777777777778
    }
  },
  "%%fuel%%" : {
    "MPG_US":{
      0: 1.0,
      1: 1.0
    },
    "MPG_UK":{
      0: 0.83267418460479,
      1: 1.2009499255398
    },
    "L_100K":{
      0: 235.214582,
      1: 235.214582
    },
    "KM_L":{
      0: 2.352145833,
      1: 0.42514370749052
    },
    "MILES_L":{
      0: 3.7854118,
      1: 0.264172052
    }
  }
};

export default function(from, number, unitFrom, unitTo) {

  if (isNaN(number)) {
    return number;
  }

  if (typeof number === 'string') {
    // this is a string
    number = number.replace(",", ".");
  }

  let fromUnit
  let toUnit

  if (from == "%%temp%%") {

    switch(unitFrom) {
      case "C°":
        switch(unitTo) {
          case "C°":
            number = (number)
            break;
          case "F°":
            number = (number * 9 / 5 + 32)
            break;
          case "K":
            return(number + 273.15)
            break;
        }
        break;
      case "F°":
        switch(unitTo) {
          case "C°":
            number = ((number - 32) * 5 / 9)
            break;
          case "F°":
            number = (number)
            break;
          case "K":
            number = ((number + 459.67) * 5 / 9)
            break;
        }
        break;
      case "K":
        switch(unitTo) {
          case "C°":
            number = (number - 273.15)
            break;
          case "F°":
            number = (number * 9 / 5 - 459.67)
            break;
          case "K":
            number = (number)
            break;
        }
        break;
    }

  } else {
    Object.entries(conversion).map((key, Mainindex) => {
      if (key[0] === from) {
        Object.entries(key[1]).map((key, Mainindex) => {
          if (key[0] == unitFrom) {
            fromUnit = key[1]['0']
          }
          if (key[0] == unitTo) {
            toUnit = key[1]['1']
          }
        })
      }
    })

    number = (number * (fromUnit*toUnit))
  }

  return Math.round(number* 10000000)/10000000
}



// WEBPACK FOOTER //
// ./src/components/Protected/Travaux/Converter.jsx